"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseComponent_1 = require("../../../../../common/js/BaseComponent");
var splide_1 = require("@splidejs/splide");
var NewsSlider = /** @class */ (function (_super) {
    __extends(NewsSlider, _super);
    function NewsSlider($view) {
        var _this = _super.call(this, $view) || this;
        _this.initSlider();
        _this.initHideArrows();
        return _this;
    }
    NewsSlider.prototype.initSlider = function () {
        var splide = new splide_1.default('#' + this.$view.attr('id'), {
            type: this.$view.data('count') > 1 ? 'loop' : 'slide',
            perPage: 3,
            perMove: 1,
            pagination: false,
            drag: true,
            breakpoints: {
                767: {
                    autoWidth: true,
                    arrows: false,
                    start: 0,
                },
            }
        });
        splide.mount();
    };
    NewsSlider.prototype.initHideArrows = function () {
        var count = this.$view.data('count');
        // Si moins de 4 slide on cache les fleches
        if (count <= 1) {
            this.$view.find('.splide__arrows').hide();
        }
    };
    return NewsSlider;
}(BaseComponent_1.default));
exports.default = NewsSlider;
